import { useMutation, useQueryClient } from 'react-query';
import { subscriptionService } from 'services';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { displayNotification } from 'utils';
import { useI18n } from 'contexts/i18n';

export const useCancelSubscription = () => {
  const queryClient = useQueryClient();
  const i18n = useI18n();
  return useMutation(
    ({
      subscriptionId,
      cancelReason,
    }: {
      subscriptionId: number;
      cancelReason: string;
    }) => {
      return subscriptionService.cancelSubscription(
        subscriptionId,
        cancelReason
      );
    },
    {
      onSuccess: (data, variables, context) => {
        displayNotification(i18n['Subscription successfully cancelled.']);
        queryClient.invalidateQueries([
          ServerStateKeysEnum.subscriptionHistory,
        ]);
      },
      onError: () => {
        displayNotification(i18n['Failed to cancel subscription!'], 'danger');
      },
    }
  );
};
